<template>
  <div class="row mt-4" v-if="membershipRequest">
    <div class="col-12 p-0">
      <p v-if="membershipRequest.paid" class="text-info">
        Вы оплатили членский взнос, заявка в обработке.
      </p>
      <p class="text-info" v-else-if="mode === 'default'">Вы уже отправили запрос на оформление членства, он не оплачен!</p>

      <p class="text-info">{{ membershipRequest.typeOfMembership === 'entrance' ? ((membershipRequest.group) ? 'Групповое оформление' : 'Оформление') : ((membershipRequest.group) ? 'Групповое продление' : 'Продление') }} членства на срок {{ period }}{{ membershipRequest.student ? ' для студентов' : ((membershipRequest.discount || membershipRequest.group) ? ' со скидкой 50%' : '') }},
      стоимостью {{ membershipRequest.price }} рублей.</p>

      <p v-if="membershipRequest.group" class="text-info">
        Организатор группы: {{ membershipRequest.organizer }}
      </p>

      <div v-if="membershipRequest.group && membershipRequest.groupRequests.length > 0">
        <p class="mb-0">Список остальных участников группы: </p>
        <div class="form-check" v-for="groupRequest in getGroupRequests" :key="groupRequest.id">
          <input
            type="checkbox"
            class="form-check-input"
            :id="'r' + groupRequest.id"
            @change="(event) => changeGroupRequest(groupRequest.id, event)"
            v-if="anyUnpaidOtherGroupRequest"
            :disabled="groupRequest.paid"
          />
          <label class="form-check-label" :for="'r' + groupRequest.id">
              {{ groupRequest.memberInfo.lastname }} {{ groupRequest.memberInfo.firstname }}
          </label>
        </div>
      </div>

      <div v-if="membershipRequest.group && !membershipRequest.groupRequests.length">
        <p class="text-warning">Кроме вас в группе пока нет ни одного участника.</p>
      </div>

      <div v-if="membershipRequest.group">
        <p class="text-info">
          <template v-if="membershipRequest.groupMembersCount">Заявленное организатором число участников группы — {{ membershipRequest.groupMembersCount }}.<br/></template>
          <template v-else>В группе должно быть не менее 5-ти человек (включая организатора).</template>
          Обработка заявок и выдача ID-карт начнётся после внесения членских взносов всеми участниками.</p>
      </div>

      <p v-if="!membershipRequest.group && cardReceiveTitle" class="text-info">
        Способ получения карты — {{ cardReceiveTitle }}.
      </p>

      <p v-if="autoProlongationEnabled" class="text-info">
        &#9745;&nbsp;Автоматическое ежегодное продление членства
      </p>

      <p v-if="!membershipRequest.paid">
          <button class="btn btn-primary" @click.prevent="completePaymentForMembership()">Оплатить членский взнос<template v-if="membershipRequest.group"> (за себя<template v-if="anyOtherRequestChecked"> и выбранных участников</template>)</template></button>
          <button class="btn btn-sm btn-default float-right cancel" @click="$emit('cancel')" v-if="cancelTitle">{{ cancelTitle }}</button>
      </p>
      <p v-else-if="anyUnpaidOtherGroupRequest">
          <button :disabled="!anyOtherRequestChecked" class="btn btn-primary" @click.prevent="completePaymentForMembership()">Оплатить членский взнос (за выбранных участников)</button>
      </p>
    </div>
  </div>
</template>

<script>
import { doShowPaymentModal } from '@/utils/MembershipPayment.js';

export default {
  props: {
    mode: {
      type: String,
      default: 'default',
    },
    cancelTitle: {
      type: String
    }
  },
  data() {
    return {
        withRequests: {},
        anyOtherRequestChecked: false,
        showPaymentDialog: false,
    }
  },
  computed: {
    period: function() {
      const leadPeriodYears = this.membershipRequest?.leadPeriodYears
      if (leadPeriodYears == 1) return '1 год'
      else if (leadPeriodYears == 3) return '3 года'
      else if (leadPeriodYears == 100) return 'пожизненно'
      return ''
    },
    anyUnpaidOtherGroupRequest() {
      let otherGroupRequests = this.getGroupRequests;
      if (otherGroupRequests) {
        for(let i in otherGroupRequests) {
          if (!otherGroupRequests[i].paid) {
            return true;
          }
        }
      }
      return false;
    },
    membershipRequest() {
      return this.$store.getters.getUserData.memberInfo?.membershipRequest
    },
    getGroupRequests: function() {
      return this.$store.getters.getUserData.memberInfo?.membershipRequest?.groupRequests
    },
    cardReceiveTitle() {
      if ('post' === this.membershipRequest?.cardReceive) {
        return 'почтой';
      }

      if ('personally' === this.membershipRequest?.cardReceive) {
        return 'лично, в офисе АОПА';
      }

      return null;
    },
    autoProlongationEnabled() {
      return !this.anyOtherRequestChecked && this.membershipRequest.autoProlongationEnabled;
    },
  },
  methods: {
    completePaymentForMembership() {
      // Завершить оплату членства
      const dataForPayment = {
        requestId: this.membershipRequest.paid ? 'NOT_FOR_MYSELF' : this.membershipRequest.id,
        withRequests: this.withRequests,
        autoProlongationEnabled: this.autoProlongationEnabled,
      };

      doShowPaymentModal(dataForPayment)

      //this.$store.dispatch('payForMembership', dataForPayment);
    },
    changeGroupRequest(id, event) {
      this.withRequests = Object.assign(this.withRequests, { [id]: event.target.checked })

      this.anyOtherRequestChecked = false;
      for(let rId in this.withRequests) {
        this.anyOtherRequestChecked = this.anyOtherRequestChecked || (this.withRequests[rId]);
      }
    }
  },
  mounted() {
    if (this.membershipRequest?.group) {
      let otherGroupRequests = this.getGroupRequests;
        for(let i in otherGroupRequests) {
          this.changeGroupRequest(otherGroupRequests[i].id, {target: {checked: false}})
        }
    }
  },
}
</script>
